<template>
    <section v-if="email && reportStore.reports[email].isReportFetch">
        <div class="row match-height">
            <div class="col-lg-2 col-md-2 col-6">
                <div class="card" :class="{ 'shadow': $route.params.client }">
                    <div class="card-body pb-50">
                        <h6>Selected Accounts</h6>
                        <h2 class="font-weight-bolder mb-1">
                            {{ getSelectedAccounts(1).length }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-6">
                <div class="card" :class="{ 'shadow': $route.params.client }">
                    <div class="card-body pb-50">
                        <h6>Selected Creditors</h6>
                        <h2 class="font-weight-bolder mb-1">
                            {{ reportStore.getUniqueSelectedCreditorAccounts().length }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-6">
                <div class="card" :class="{ 'shadow': $route.params.client }">
                    <div class="card-body pb-50">
                        <h6>Selected Public Records</h6>
                        <h2 class="font-weight-bolder mb-1">
                            {{ getSelectedAccounts(1, 'public-record').length }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-6">
                <div class="card" :class="{ 'shadow': $route.params.client }">
                    <div class="card-body pb-50">
                        <h6>Selected Data Furnisher</h6>
                        <h2 class="font-weight-bolder mb-1">
                            {{ filterDataFurnisher(1).length }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-6">
                <div class="card" :class="{ 'shadow': $route.params.client }">
                    <div class="card-body pb-50">
                        <h6>Selected Inquiries</h6>
                        <h2 class="font-weight-bolder mb-1">
                            {{ selectedInquiries(1).length }}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" :class="{ 'shadow': $route.params.client }" >
            <div class="card-body">
                <div class="demo-inline-spacing">
                    <div class="form-group my-0">
                        <button type="button" @click="clearFilter" class="btn btn-outline-danger mt-0">Clear Filter</button>
                    </div>
                    <!--  -->
                    <div class="form-group my-0">
                        <button type="button" class="btn btn-outline-primary mt-0 d-flex" data-toggle="modal" data-target="#dispute_center_video_model">
                            <vue-feather type="film" size="18"></vue-feather>
                            <span style="
                                margin-top: 2px;
                                padding-left: 5px;
                            "> Tutorial</span>
                        </button>
                    </div>
                    <div class="form-group my-0">
                        <button type="button" class="btn btn-outline-primary mt-0 d-flex" data-toggle="modal" data-target="#attack_modal" v-if="reportStore.disputeCenterActiveTab == 4">
                            <vue-feather type="film" size="18"></vue-feather>
                            <span style="
                                margin-top: 2px;
                                padding-left: 5px;
                            "> Attack Guide</span>
                        </button>
                    </div>

                    <div class="form-group my-0 ml-auto">
                        <button @click="section = 'report',setActiveReportTab('report')" type="button" class="btn btn-outline-primary mt-0" :class="{ active: section == 'report' }">
                            All Accounts
                        </button>
                    </div>
                    <div class="form-group my-0">
                        <button @click="section = 'dispute-center',setActiveReportTab('dispute-center')" type="button" class="btn btn-outline-primary mt-0" :class="{ active: section == 'dispute-center' }">
                            Disputes
                        </button>
                    </div>
                    <div class="form-group my-0">
                        <button @click="section = 'dispute-tracker',setActiveReportTab('dispute-tracker')" type="button" class="btn btn-outline-primary mt-0" :class="{ active: section == 'dispute-tracker' }">
                                {{ localizationStore.translate("Dispute Tracker") }}
                        </button>
                        <!-- <button @click="section = 'dispute-tracker'" type="button" class="btn btn-outline-primary mt-0" :class="{ active: section == 'dispute-tracker' }">
                            <template v-if="$route.params.client">
                                {{ localizationStore.translate("attack.history") }}
                            </template>
                            <template v-else >
                                {{ localizationStore.translate("Dispute Tracker") }}
                            </template>
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="section == 'report'">
            <ul class="nav nav-pills nav-justified">
                <li class="nav-item">
                    <a class="nav-link active" id="accounts_tab" data-toggle="pill" href="#accounts-pill" aria-expanded="false">
                        <p class="mb-0">
                            All Accounts ({{ reportStore.reports[email].report.accounts.length }})
                        </p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="public_records_tab" data-toggle="pill" href="#public-records-pill" aria-expanded="false">
                        <p class="mb-0">
                            Public Records ({{ reportStore.reports[email].report.listPublicRecords.length }})
                        </p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="data_furnishers_tab" data-toggle="pill" href="#data-furnishers-pill" aria-expanded="false">
                        <p class="mb-0">
                            Data Furnishers ({{ reportStore.reports[email].report.dataFurnishers.length }})
                        </p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="inquiries_tab" data-toggle="pill" href="#inquiries-pill" aria-expanded="false">
                        <p class="mb-0">
                            Inquiries ({{ reportStore.reports[email].report.inquiries.length }})
                        </p>
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" role="tab-pane"  id="accounts-pill" aria-labelledby="accounts_tab" aria-expanded="true">
                    <div v-if="reportStore.reports[email].report.accounts != null && reportStore.reports[email].report.accounts.length > 0" class="row">
                        <div class="col-sm-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }" >
                                <div class="card-body">
                                    <div class="demo-inline-spacing">
                                        <div v-if="getSelectedAccounts(1).length > 0" class="form-group my-0">
                                            <button
                                                type="button"
                                                @click="deselectAllBureaus()"
                                                class="btn btn-outline-primary"
                                            >
                                                Deselect All
                                            </button>
                                        </div>
                                        <div class="form-group my-0">
                                            <input type="text" class="form-control" v-model="accountSearch" placeholder="Search" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" :class="{ 'shadow': $route.params.client }" >
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-4 col-xl-4 col-md-4" v-for="(account, loop) in getAccounts">
                                        <div
                                            class="card border shadow-none bg-transparent"
                                            :class="reportStore.borderClass(account)"
                                        >
                                            <div class="card-header border-bottom">
                                                <div class="d-flex justify-content-between align-items-center w-100">
                                                    <h4 class="card-title text-primary account-title">
                                                        <strong>
                                                            {{ reportStore.getAccountDetail(account).furnisher_name }}
                                                        </strong>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="card-body p-1">
                                                <p class="card-text mb-0">
                                                    <span class="text-secondary">
                                                        <strong>
                                                            <i class="fa fa-align-left"></i>
                                                            ACCOUNT NUMBER:
                                                        </strong>
                                                    </span>
                                                    {{ reportStore.getAccountDetail(account).account_number }}
                                                </p>
                                                <p class="card-text mb-0">
                                                    <span class="text-secondary">
                                                        <strong style="font-size:12px">
                                                            <i class="fa fa-usd"></i>
                                                            ACCOUNT BALANCE:
                                                        </strong>
                                                    </span>
                                                    {{ reportStore.getAccountDetail(account).balance }}
                                                </p>
                                                <p class="card-text mb-0" >
                                                    <span class="text-secondary">
                                                        <strong style="font-size:12px">
                                                            <i class="fa fa-info-circle "></i>
                                                            ACCOUNT STATUS:
                                                        </strong>
                                                    </span>
                                                    <span>
                                                        {{ reportStore.getAccountDetail(account).account_status }}
                                                    </span>
                                                </p>
                                                <p class="card-text mb-1">
                                                    <span class="text-secondary">
                                                        <strong style="font-size:12px">
                                                            <i class="fa fa-info-circle"></i>
                                                            PAYMENT STATUS:
                                                        </strong>
                                                    </span>
                                                    <span
                                                        class="badge badge-pill badge-glow badge-down"
                                                        :class="reportStore.badgeClass(account)"
                                                    >
                                                        {{ reportStore.getAccountDetail(account).payment_status }}
                                                    </span>
                                                </p>
                                                <a
                                                    href="javascript:void(0)"
                                                    class="btn-sm btn-outline-primary"
                                                    data-toggle="modal"
                                                    :data-target="'#accountHistories_modal_' + loop"
                                                >
                                                    View Details
                                                </a>
                                            </div>
                                            <div class="card-footer text-muted">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <h4 class="card-title mb-0">Dispute Reason:</h4>
                                                </div>
                                                <div class="form-group mt-1">
                                                    <Select2
                                                        @select="updateReason($event, account[4])"
                                                        v-model="account[4].disputeReason"
                                                        placeholder="Select Reason Or Type your Custom Reason Below"
                                                        :options="reportStore.options.accounts"
                                                    />
                                                    <textarea
                                                        class="form-control mt-50"
                                                        rows="3"
                                                        v-model="account[4].reason"
                                                        placeholder="Custom Dispute Reason"
                                                    ></textarea>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center mt-1">
                                                    <di v class="custom-control custom-control-primary custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            :id="`creditor-${loop}`"
                                                            v-model="account[4].isCreditorSelected"
                                                            @change="updateCreditor(loop)"
                                                            true-value="1"
                                                            false-value="0"
                                                        />
                                                        <label class="custom-control-label" :for="`creditor-${loop}`">Dispute Creditor</label>
                                                    </di>
                                                    <select @change="updateCreditor(loop)" v-if="account[4].isCreditorSelected == 1" class="form-select creditors-greens" v-model="account[4].creditor">
                                                        <option v-for="(creditContact) in reportStore.reports[email].report.creditContacts" :value="creditContact.id">{{ creditContact.creditor_name }}</option>
                                                    </select>
                                                </div>
                                                <div class="demo-inline-spacing">
                                                    <div class="custom-control custom-control-primary custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            :id="`all-bureaus-${loop}`"
                                                            v-model="account[3]"
                                                            @change="selectDeselectBureaus(account, 'all')"
                                                            true-value="1"
                                                            false-value="0"
                                                        />
                                                        <label class="custom-control-label" :for="`all-bureaus-${loop}`">All Bureaus</label>
                                                    </div>
                                                    <div class="custom-control custom-control-primary custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            :id="`transunion${loop}`"
                                                            v-model="account[0].checkbox"
                                                            @change="selectDeselectBureaus(account, 'transunion')"
                                                            true-value="1"
                                                            false-value="0"
                                                            :disabled="reportStore.isReportedByBureau(account[0])"
                                                        />
                                                        <label class="custom-control-label" :for="`transunion${loop}`">TransUnion</label>
                                                    </div>
                                                    <div class="custom-control custom-control-primary custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            :id="`experian${loop}`"
                                                            v-model="account[1].checkbox"
                                                            @change="selectDeselectBureaus(account, 'experian')"
                                                            true-value="1"
                                                            false-value="0"
                                                            :disabled="reportStore.isReportedByBureau(account[1])"
                                                        />
                                                        <label class="custom-control-label" :for="`experian${loop}`">Experian</label>
                                                    </div>
                                                    <div class="custom-control custom-control-primary custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            :id="`equifax${loop}`"
                                                            v-model="account[2].checkbox"
                                                            @change="selectDeselectBureaus(account, 'equifax')"
                                                            true-value="1"
                                                            false-value="0"
                                                            :disabled="reportStore.isReportedByBureau(account[2])"
                                                        />
                                                        <label class="custom-control-label" :for="`equifax${loop}`">Equifax</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <account-detail-modal :email="email" :account="account" :id="'accountHistories_modal_' + loop" account-type="all">
                                            </account-detail-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section v-else-if="!reportStore.reports[email].haveReport">
                        <div class="col-sm-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }" >
                                <div class="card-body">
                                    <div class="mx-auto">
                                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                                        </h6>
                                    </div>
                                    <div style="text-align:center;">
                                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                                            class="btn btn-warning ">
                                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <p v-else class="text-center font-medium-3 text-bold-600 warning">You don't have any Report Data.</p>
                </div>
                <div class="tab-pane" role="tab-pane" id="public-records-pill" aria-labelledby="public_records_tab" aria-expanded="true">
                    <div v-if="reportStore.reports[email].report.listPublicRecords != null && reportStore.reports[email].report.listPublicRecords.length > 0" class="row">
                        <div class="col-sm-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-4 col-xl-4 col-md-4 col-sm-12" v-for="(publicRecord, loop) in reportStore.reports[email].report.listPublicRecords">
                                            <div class="card shadow-none bg-transparent border-success">
                                                <div class="card-body">
                                                    <h4 class="card-title mb-50 text-primary account-title">
                                                        <strong>
                                                            {{ reportStore.getAccountDetail(publicRecord, 'public-record').furnisher_name }}
                                                        </strong>
                                                    </h4>
                                                    <p class="card-text mb-0">
                                                        <span class="text-secondary">
                                                            <strong>
                                                                <i class="fa fa-align-left"></i>
                                                                Reference Number:
                                                            </strong>
                                                        </span>
                                                        {{ reportStore.getAccountDetail(publicRecord, 'public-record').reference_number }}
                                                    </p>
                                                    <p class="card-text mb-0">
                                                        <span class="text-secondary">
                                                            <strong style="font-size:12px">
                                                                <i class="fa fa-usd"></i>
                                                                TYPE:
                                                            </strong>
                                                        </span>
                                                        {{ reportStore.getAccountDetail(publicRecord, 'public-record').type }}
                                                    </p>
                                                    <p class="card-text mb-0" >
                                                        <span class="text-secondary">
                                                            <strong style="font-size:12px">
                                                                <i class="fa fa-info-circle "></i>
                                                                ACCOUNT STATUS:
                                                            </strong>
                                                        </span>
                                                        <span>
                                                            {{ reportStore.getAccountDetail(publicRecord, 'public-record').status }}
                                                        </span>
                                                    </p>
                                                    <p class="card-text mb-0">
                                                        <span class="text-secondary">
                                                            <strong style="font-size:12px">
                                                                <i class="fa fa-info-circle"></i>
                                                                DATE FILED:
                                                            </strong>
                                                        </span>
                                                        <span class="badge badge-pill badge-glow badge-down">
                                                            {{ reportStore.getAccountDetail(publicRecord, 'public-record').date_filed_reported }}
                                                        </span>
                                                    </p>
                                                    <p class="text-primary float-right mb-0" style="font-size:12px;cursor: pointer;" data-toggle="modal" :data-target="'#public_records_modal_'+loop">
                                                        <u>View Details</u>
                                                    </p>
                                                </div>
                                                <div class="card-footer text-muted">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <h4 class="card-title mb-0">Dispute Public Record:</h4>
                                                    </div>
                                                    <div class="form-group mt-1">
                                                        <Select2
                                                            @select="updateReason($event, publicRecord[0])"
                                                            v-model="publicRecord[0].disputeReason"
                                                            placeholder="Select Reason Or Type your Custom Reason Below"
                                                            :options="reportStore.options.publicRecords"
                                                        />
                                                        <textarea
                                                            class="form-control mt-50"
                                                            rows="3"
                                                            v-model="publicRecord[0].reason"
                                                            placeholder="Custom Dispute Reason"
                                                        ></textarea>
                                                    </div>
                                                    <div class="demo-inline-spacing">
                                                        <div class="custom-control custom-control-primary custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="`all-public-record-${loop}`"
                                                                v-model="publicRecord[3]"
                                                                @change="selectDeselectBureaus(publicRecord, 'all')"
                                                                true-value="1"
                                                                false-value="0"
                                                            />
                                                            <label class="custom-control-label" :for="`all-public-record-${loop}`">All Bureaus</label>
                                                        </div>
                                                        <div class="custom-control custom-control-primary custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="`public-record-transunion${loop}`"
                                                                v-model="publicRecord[0].checkbox"
                                                                @change="selectDeselectBureaus(publicRecord, 'transunion')"
                                                                true-value="1"
                                                                false-value="0"
                                                                :disabled="reportStore.isReportedByBureau(publicRecord[0], 'public-record')"
                                                            />
                                                            <label class="custom-control-label" :for="`public-record-transunion${loop}`">TransUnion</label>
                                                        </div>
                                                        <div class="custom-control custom-control-primary custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="`public-record-experian${loop}`"
                                                                v-model="publicRecord[1].checkbox"
                                                                @change="selectDeselectBureaus(publicRecord, 'experian')"
                                                                true-value="1"
                                                                false-value="0"
                                                                :disabled="reportStore.isReportedByBureau(publicRecord[1], 'public-record')"
                                                            />
                                                            <label class="custom-control-label" :for="`public-record-experian${loop}`">Experian</label>
                                                        </div>
                                                        <div class="custom-control custom-control-primary custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="`public-record-equifax${loop}`"
                                                                v-model="publicRecord[2].checkbox"
                                                                @change="selectDeselectBureaus(publicRecord, 'equifax')"
                                                                true-value="1"
                                                                false-value="0"
                                                                :disabled="reportStore.isReportedByBureau(publicRecord[2], 'public-record')"
                                                            />
                                                            <label class="custom-control-label" :for="`public-record-equifax${loop}`">Equifax</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="modal fade text-left" :id="'public_records_modal_'+loop" tabindex="-1" role="dialog" aria-labelledby="public_records_modal" aria-hidden="true">
                                                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <h4 class="modal-title" id="myModalLabel16">{{ reportStore.getAccountDetail(publicRecord, 'public-record').furnisher_name }}</h4>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <div class="table-responsive">
                                                                <table class="table table-success table-striped table-hover mb-0">
                                                                    <thead class="thead-primary">
                                                                        <tr>
                                                                            <th style="width:100px"></th>
                                                                            <th style="width:100px">
                                                                                <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                                                            </th>
                                                                            <th style="width:100px">
                                                                                <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                                                            </th>
                                                                            <th style="width:100px">
                                                                                <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody class="table-striped" >
                                                                        <tr scope="row">
                                                                            <td>Reference Number</td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[0].reference_number }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[1].reference_number }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[2].reference_number }}
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                        <tr scope="row">
                                                                            <td>TYPE</td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[0].type }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[1].type }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[2].type }}
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                        <tr scope="row">
                                                                            <td>ACCOUNT STATUS</td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[0].status }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[1].status }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[2].status }}
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                        <tr scope="row">
                                                                            <td>DATE FILED</td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[0].date_filed_reported }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[1].date_filed_reported }}
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p class="mb-0">
                                                                                    {{ publicRecord[2].date_filed_reported }}
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section v-else-if="!reportStore.reports[email].haveReport">
                        <div class="col-sm-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }" >
                                <div class="card-body">
                                    <div class="mx-auto">
                                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                                        </h6>
                                    </div>
                                    <div style="text-align:center;">
                                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                                            class="btn btn-warning ">
                                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <p v-else class="text-center font-medium-3 text-bold-600 warning"> You don't have any Public Records.</p>
                </div>
                <div class="tab-pane" role="tab-pane" id="data-furnishers-pill" aria-labelledby="data_furnishers_tab" aria-expanded="true">
                    <div v-if="reportStore.reports[email].report.dataFurnishers != null && reportStore.reports[email].report.dataFurnishers.length > 0" class="row">
                        <div class="col-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }">
                                <div class="card-body">
                                    <div class="demo-inline-spacing">
                                        <div v-if="filterDataFurnisher(1).length > 0" class="form-group my-0">
                                            <button
                                                type="button"
                                                @click="deselectAllDataFurnisher()"
                                                class="btn btn-outline-primary"
                                            >
                                                Deselect All Data Furnisher
                                            </button>
                                        </div>
                                        <div class="mt-0">
                                            <input type="text" class="form-control" v-model="dataFurnisherSearch" placeholder="Search" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card" :class="{ 'shadow': $route.params.client }">
                                <div class="card-content">
                                    <div class="card-body">
                                        <div v-if="filterDataFurnisher() != null && filterDataFurnisher().length > 0" class="row match-height">
                                            <div class="col-lg-4 col-xl-4 col-md-4" v-for="dataFurnisher in filterDataFurnisher()">
                                                <div class="card shadow-none bg-transparent border-success">
                                                    <div class="card-body">
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <div class="custom-control custom-control-primary custom-checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        class="custom-control-input"
                                                                        :id="`data_furnisher_${dataFurnisher.id}`"
                                                                        v-model="dataFurnisher.checkbox"
                                                                        @change="updateDataFurnisher(dataFurnisher.id)"
                                                                        true-value="1"
                                                                        false-value="0"
                                                                    />
                                                                    <label class="custom-control-label" :for="`data_furnisher_${dataFurnisher.id}`"></label>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <span class="card-text mb-50 text-primary">
                                                                        <strong style="font-size:14px">
                                                                            Name:
                                                                        </strong>
                                                                    </span>
                                                                    {{ dataFurnisher.name }}
                                                                </div>
                                                                <div>
                                                                    <span class="card-text mb-50 text-primary">
                                                                        <strong style="font-size:14px">
                                                                            Category:
                                                                        </strong>
                                                                    </span>
                                                                    {{ reportStore.getDataFurnishersCategoryName(dataFurnisher.category_id) }}
                                                                </div>
                                                                <div>
                                                                    <span class="card-text mb-50 text-primary">
                                                                        <strong style="font-size:14px">
                                                                            Website:
                                                                        </strong>
                                                                    </span>
                                                                    {{ dataFurnisher.website }}
                                                                </div>
                                                                <div>
                                                                    <span class="card-text mb-50 text-primary">
                                                                        <strong style="font-size:14px">
                                                                            Phone Number:
                                                                        </strong>
                                                                    </span>
                                                                    {{ dataFurnisher.phone_number }}
                                                                </div>
                                                            </div>
                                                            <div v-if="dataFurnisher.logo_url">
                                                                <img :src="dataFurnisher.logo_url" alt="image" width="100" height="100">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn-primary m-2" @click="setDataFurnisherData(dataFurnisher)"> Learn More </button>
                                                </div>
                                            </div>
                                        </div>
                                        <p v-else class="text-center font-medium-3 text-bold-600 warning">No Record Found.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section v-else-if="!reportStore.reports[email].haveReport">
                        <div class="col-sm-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }" >
                                <div class="card-body">
                                    <div class="mx-auto">
                                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                                        </h6>
                                    </div>
                                    <div style="text-align:center;">
                                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                                            class="btn btn-warning ">
                                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <p v-else class="text-center font-medium-3 text-bold-600 warning">You don't have any Report Data.</p>
                </div>
                <div class="tab-pane" role="tab-pane" id="inquiries-pill" aria-labelledby="inquiries_tab" aria-expanded="true">
                    <div v-if="reportStore.reports[email].report.inquiries != null && reportStore.reports[email].report.inquiries.length > 0" class="row">
                        <div class="col-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }">
                                <div class="card-body">
                                    <div class="demo-inline-spacing">
                                        <div class="custom-control custom-control-primary custom-checkbox mt-0">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="select-deselect"
                                                @click="selectDeselect()"
                                                v-model="isSelected"
                                                true-value="1"
                                                false-value="0"
                                            />
                                            <label class="custom-control-label" for="select-deselect" v-html="select == 0 ? 'Select All' : 'Deselect All'"></label>
                                        </div>
                                        <div class="custom-control custom-radio mt-0">
                                            <input
                                                id="All"
                                                type="radio"
                                                value="All"
                                                class="custom-control-input"
                                                v-model="creditBureau"
                                            />
                                            <label class="custom-control-label" for="All">All ({{ filter('All').length }})</label>
                                        </div>
                                        <div class="custom-control custom-radio mt-0">
                                            <input
                                                id="TransUnion"
                                                type="radio"
                                                value="TransUnion"
                                                class="custom-control-input"
                                                v-model="creditBureau"
                                            />
                                            <label class="custom-control-label" for="TransUnion">TransUnion ({{ filter('TransUnion').length }})</label>
                                        </div>
                                        <div class="custom-control custom-radio mt-0">
                                            <input
                                                id="Experian"
                                                type="radio"
                                                value="Experian"
                                                class="custom-control-input"
                                                v-model="creditBureau"
                                            />
                                            <label class="custom-control-label" for="Experian">Experian ({{ filter('Experian').length }})</label>
                                        </div>
                                        <div class="custom-control custom-radio mt-0">
                                            <input
                                                id="Equifax"
                                                type="radio"
                                                value="Equifax"
                                                class="custom-control-input"
                                                v-model="creditBureau"
                                            />
                                            <label class="custom-control-label" for="Equifax">Equifax ({{ filter('Equifax').length }})</label>
                                        </div>
                                        <div class="mt-0">
                                            <input type="text" class="form-control" v-model="inquirySearch" placeholder="Search" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card" :class="{ 'shadow': $route.params.client }">
                                <div class="card-content">
                                    <div class="card-body">
                                        <div v-if="filterInquiries != null && filterInquiries.length > 0" class="row match-height">
                                            <div class="col-lg-4 col-xl-4 col-md-4" v-for="(inquiry, loop) in filterInquiries">
                                                <div class="card shadow-none bg-transparent border-success">
                                                    <div class="card-header border-bottom">
                                                        <div class="d-flex justify-content-between w-100">
                                                            <div>
                                                                <h4 class="card-title text-primary">
                                                                    <strong>
                                                                        {{ inquiry.creditor_name }}
                                                                    </strong>
                                                                </h4>
                                                                <p class="text-primary">
                                                                    <strong>
                                                                        {{ inquiry.date_of_inquiry }}
                                                                    </strong>
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <img :src="reportStore.getBureauImage(inquiry.credit_bureau)" alt="image">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-footer text-muted">
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <h4 class="card-title mb-0">Dispute Inquiry:</h4>
                                                        </div>
                                                        <div class="form-group mt-1">
                                                            <Select2
                                                                @select="updateReason($event, inquiry)"
                                                                v-model="inquiry.disputeReason"
                                                                placeholder="Select Reason Or Type your Custom Reason Below"
                                                                :options="reportStore.options.inquiries"
                                                            />
                                                            <textarea
                                                                class="form-control mt-50"
                                                                rows="3"
                                                                v-model="inquiry.reason"
                                                                placeholder="Custom Dispute Reason"
                                                            ></textarea>
                                                        </div>
                                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                                            <div class="custom-control custom-control-primary custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    class="custom-control-input"
                                                                    :id="`inquiry_${inquiry.id}`"
                                                                    v-model="inquiry.checkbox"
                                                                    true-value="1"
                                                                    false-value="0"
                                                                />
                                                                <label class="custom-control-label" :for="`inquiry_${inquiry.id}`">Dispute Inquiry</label>
                                                            </div>
                                                            <select v-if="inquiry.checkbox == 1" class="form-select mt-50 creditors-greens" v-model="inquiry.creditor">
                                                                <option v-for="(creditContact) in reportStore.reports[email].report.creditContacts" :value="creditContact.id">{{ creditContact.creditor_name }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p v-else class="text-center font-medium-3 text-bold-600 warning">No Record Found.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section v-else-if="!reportStore.reports[email].haveReport">
                        <div class="col-sm-12">
                            <div class="card" :class="{ 'shadow': $route.params.client }" >
                                <div class="card-body">
                                    <div class="mx-auto">
                                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                                        </h6>
                                    </div>
                                    <div style="text-align:center;">
                                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                                            class="btn btn-warning ">
                                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <p v-else class="text-center font-medium-3 text-bold-600 warning">You don't have any Report Data.</p>
                </div>
            </div>
        </div>
        <div class="row" v-if="section == 'dispute-center'">
            <dispute-center-component />
        </div>
        <div class="row" v-show="section == 'dispute-tracker'">
            <div class="col-12">
                <!-- <attack-history v-if="$route.params.client" /> -->
                <!-- <dispute-tracker v-if="!$route.params.client" /> -->
                <dispute-tracker/>
            </div>
        </div>
    </section>
    <loading v-else />
    <data-furnisher-model :id="'DataFurnisherModal'"/>
</template>
<style>
    select.creditors-greens option,
    select.creditors-greens optgroup {
        color: #b9b9c3;
    }
    select.creditors-greens:not(:checked) {
        color: #28c76f;
    }
    .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #28c76f;
    }
</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import Loader from '../report/Loader'
    import Swal from 'sweetalert2'
    import Select2 from 'vue3-select2-component';
    import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
    export default {
        props:{
        },
        mounted() {
            if (this.$route.params.client) {
                useUserStore().fetchUser();
            }
            let value = this.userStore.user;
            if (value != null) {
                if (!value.isBusinessUser) {
                    this.email = value.email;
                }
                else {
                    this.email = this.clientEmail;
                }
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
            if(_.isNull(this.section) && (_.isEmpty(localStorage.getItem('report_active_section')) || _.isUndefined(localStorage.getItem('report_active_section')))){
                this.setActiveReportTab('report');
                this.section = 'report'
            }else{
                this.section = localStorage.getItem('report_active_section')
            }

        },
        components: {
            'loading': Loader,
            Select2
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                creditBureau: ref('All'),
                select: ref(0),
                accountSearch: ref(''),
                inquirySearch: ref(''),
                dataFurnisherSearch: ref(''),
                email: ref(null),
                section: ref(null),
                openModal:openModal
            }
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    this.email = value.email;
                    if (!this.reportStore.reports[this.email]) {
                        this.reportStore.getReport();
                    }
                }
            },
        },
        computed: {
            filterInquiries() {
                return this.filter(this.creditBureau);
            },
            selectedInquiries() {
                return function (selected) {
                    return this.getSelectedInquiries(selected);
                };
            },
            isSelected() {
                if (this.reportStore.reports[this.email].report.inquiries.length == this.getSelectedInquiries(1).length) {
                    this.select = 1;
                }
                else {
                    this.select = 0;
                }
                return this.select;
            },
            getAccounts() {
                if (this.accountSearch == '') {
                    return this.reportStore.reports[this.email].report.accounts;
                }
                let $this = this;
                if ($this.accountSearch != '' && $this.reportStore.reports[this.email].report.accounts.length > 0) {
                    return _.filter($this.reportStore.reports[this.email].report.accounts, function(account) {
                        return account[0].furnisher_name.toLowerCase().includes($this.accountSearch.toLowerCase())
                        ||
                        account[1].furnisher_name.toLowerCase().includes($this.accountSearch.toLowerCase())
                        ||
                        account[2].furnisher_name.toLowerCase().includes($this.accountSearch.toLowerCase());
                    });
                }
            },
            filterDataFurnisher() {
                return function (selected = null) {
                    return this.getFilterDataFurnisher(selected);
                }
            },
        },
        methods: {
            filter(type) {
                let $this = this;
                if (type != 'All') {
                    return _.filter($this.reportStore.reports[this.email].report.inquiries, function (inquiry, index) {
                        if (
                            inquiry.credit_bureau == type
                            &&
                            inquiry.creditor_name.toLowerCase().includes($this.inquirySearch.toLowerCase())
                        ) {
                            return inquiry;
                        }
                    });
                }
                if ($this.inquirySearch == '') {
                    return $this.reportStore.reports[this.email].report.inquiries;
                }
                return _.filter($this.reportStore.reports[this.email].report.inquiries, function (inquiry, index) {
                    if (inquiry.creditor_name.toLowerCase().includes($this.inquirySearch.toLowerCase())) {
                        return inquiry;
                    }
                });
            },
            selectDeselect() {
                let $this = this;
                $this.select = $this.select == 0 ? 1 : 0;
                _.filter($this.reportStore.reports[this.email].report.inquiries, function (inquiry, index) {
                    inquiry.checkbox = $this.select;
                });
            },
            selectDeselectBureaus(account, type) {
                if (type == 'all') {
                    _.forEach(account, function(value, index) {
                        if (((typeof value.checkbox == "undefined") || (value.checkbox != 2)) && index < 3) {
                            value.checkbox = account[3];
                        }
                    });
                }
                else {
                    let isAccountCheckedCount = 0;
                    _.forEach(account, function(value, index) {
                        if ((value.checkbox == 2 || value.checkbox == 1) && index < 3) {
                            isAccountCheckedCount = isAccountCheckedCount + 1;
                        }
                    });
                    account[3] = isAccountCheckedCount == 3 ? 1 : 0;
                }
            },
            deselectAllBureaus() {
                _.forEach(this.reportStore.reports[this.email].report.accounts, function(account) {
                    account[3] = 0;
                    _.forEach(account, function(value, index) {
                        if (((typeof value.checkbox == "undefined") || (value.checkbox != 2)) && index < 3) {
                            value.checkbox = 0;
                        }
                    });
                });
            },
            deselectAllDataFurnisher() {
                _.forEach(this.reportStore.reports[this.email].report.dataFurnishers, function(dataFurnisher) {
                    dataFurnisher.checkbox = 0;
                });
            },
            getSelectedInquiries(selected) {
                return _.filter(this.reportStore.reports[this.email].report.inquiries, function (inquiry) {
                    if (inquiry.checkbox == selected) {
                        return inquiry;
                    }
                });
            },
            getSelectedAccounts(selected, type = null) {
                if (_.isNull(type)) {
                    return _.filter(this.reportStore.reports[this.email].report.accounts, function (account) {
                        if (
                            account[0].checkbox == selected
                            ||
                            account[1].checkbox == selected
                            ||
                            account[2].checkbox == selected
                            ||
                            account[3].checkbox == selected
                        ) {
                            return account;
                        }
                    });
                }
                return _.filter(this.reportStore.reports[this.email].report.listPublicRecords, function (publicRecords) {
                    if (
                        publicRecords[0].checkbox == selected
                        ||
                        publicRecords[1].checkbox == selected
                        ||
                        publicRecords[2].checkbox == selected
                        ||
                        publicRecords[3].checkbox == selected
                    ) {
                        return publicRecords;
                    }
                });
            },
            clearFilter() {
                let $this = this;
                Swal.fire({
                    title: 'Are you sure you want to clear filter?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        $this.reportStore.reports[$this.email].filter.accounts = [];
                        $this.reportStore.reports[$this.email].filter.inquiries = [];
                        $this.reportStore.getReport();
                    }
                });
            },
            shiftTab()
            {
                document.getElementById('clientDispute-tab').click();
            },
            updateCreditor(loop)
            {
                if (this.reportStore.getUniqueSelectedCreditorAccounts().length > 10) {
                    this.getAccounts[loop][4].isCreditorSelected = 0;
                    // account
                    // isSelected = 0;
                    toastr.error("You can not Dispute more than 10 creditors", 'Error!');
                }

            },
            updateDataFurnisher(dataFurnisherId)
            {
                if (this.filterDataFurnisher(1).length > 10) {
                    _.filter(this.reportStore.reports[this.email].report.dataFurnishers, function (dataFurnisher, index) {
                        if (dataFurnisher.id == dataFurnisherId) {
                            dataFurnisher.checkbox = 0;
                        }
                    });
                    toastr.error("You can not Dispute more than 10 Data Furnisher", 'Error!');
                }

            },
            getFilterDataFurnisher(selected) {
                let $this = this;
                if (_.isNull(selected)) {
                    return _.filter($this.reportStore.reports[this.email].report.dataFurnishers, function (dataFurnisher, index) {
                        if (dataFurnisher.name.toLowerCase().includes($this.dataFurnisherSearch.toLowerCase())) {
                            return dataFurnisher;
                        }
                    });
                }
                return _.filter($this.reportStore.reports[this.email].report.dataFurnishers, function (dataFurnisher, index) {
                    if (dataFurnisher.checkbox == selected) {
                        return dataFurnisher;
                    }
                });
            },
            updateReason($event, account) {
                if (account.disputeReason == 'null') {
                    account.reason = '';
                    return;
                }
                account.reason = this.reportStore.getDisputeReasonById(account.disputeReason).description;
            },
            setDataFurnisherData(data){
                openModal('#DataFurnisherModal')
                this.reportStore.selectedDataFurnisherData = data
            },
            setActiveReportTab(activeTab){
                localStorage.setItem('report_active_section',activeTab);
            }

        }
    }
</script>
